import React from 'react';
import { LayoutDashboard, Receipt, Building2, MessageSquare, FileOutput, Users, Settings, BellIcon, UserCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export const DashboardPage = () => {
  const location = useLocation();
  const navigationItems = [{
    icon: <LayoutDashboard size={20} data-id="element-246" />,
    label: 'Dashboard',
    path: '/app'
  }, {
    icon: <Building2 size={20} data-id="element-247" />,
    label: 'Banking',
    path: '/app/banking'
  }, {
    icon: <Receipt size={20} data-id="element-248" />,
    label: 'Belege',
    path: '/app/receipts'
  }, {
    icon: <MessageSquare size={20} data-id="element-249" />,
    label: 'KI-Assistent',
    path: '/app/ai-assistant'
  }, {
    icon: <FileOutput size={20} data-id="element-250" />,
    label: 'Export',
    path: '/app/export'
  }, {
    icon: <Users size={20} data-id="element-251" />,
    label: 'Team',
    path: '/app/team'
  }, {
    icon: <Settings size={20} data-id="element-252" />,
    label: 'Einstellungen',
    path: '/app/settings'
  }];
  return <div className="flex h-screen bg-gray-50" data-id="element-253">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-gray-200" data-id="element-254">
        <div className="h-full flex flex-col" data-id="element-255">
          <div className="flex items-center space-x-2 px-6 py-4 border-b border-gray-200" data-id="element-256">
            <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-257">
              <span className="text-white font-bold" data-id="element-258">T</span>
            </div>
            <span className="text-xl font-bold text-gray-900" data-id="element-259">TaxTidy</span>
          </div>
          <nav className="flex-1 p-4" data-id="element-260">
            <ul className="space-y-1" data-id="element-261">
              {navigationItems.map((item, index) => <li key={index} data-id="element-262">
                  <Link to={item.path} className={`flex items-center space-x-3 px-3 py-2 rounded-md text-sm ${location.pathname === item.path ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-263">
                    {item.icon}
                    <span className="font-medium" data-id="element-264">{item.label}</span>
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>
      </aside>
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-265">
        {/* Top Header */}
        <header className="bg-white border-b border-gray-200" data-id="element-266">
          <div className="flex items-center justify-between px-6 py-4" data-id="element-267">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-268">Dashboard</h1>
            <div className="flex items-center space-x-4" data-id="element-269">
              <button className="text-gray-600 hover:text-gray-900" data-id="element-270">
                <BellIcon size={20} data-id="element-271" />
              </button>
              <button className="flex items-center space-x-2 text-gray-700 hover:text-gray-900" data-id="element-272">
                <UserCircle size={20} data-id="element-273" />
                <span className="text-sm font-medium" data-id="element-274">Max Mustermann</span>
              </button>
            </div>
          </div>
        </header>
        {/* Dashboard Content */}
        <main className="flex-1 overflow-auto p-6" data-id="element-275">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" data-id="element-276">
            {/* Stats Cards */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-277">
              <h3 className="text-sm font-medium text-gray-500 mb-4" data-id="element-278">
                Offene Aufgaben
              </h3>
              <p className="text-2xl font-bold text-gray-900" data-id="element-279">7</p>
              <div className="mt-2" data-id="element-280">
                <span className="text-sm text-red-600 font-medium" data-id="element-281">
                  4 dringend
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-282">
              <h3 className="text-sm font-medium text-gray-500 mb-4" data-id="element-283">
                Belege heute
              </h3>
              <p className="text-2xl font-bold text-gray-900" data-id="element-284">12</p>
              <div className="mt-2" data-id="element-285">
                <span className="text-sm text-green-600 font-medium" data-id="element-286">
                  8 zugeordnet
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-287">
              <h3 className="text-sm font-medium text-gray-500 mb-4" data-id="element-288">
                KI-Score
              </h3>
              <p className="text-2xl font-bold text-gray-900" data-id="element-289">94%</p>
              <div className="mt-2" data-id="element-290">
                <span className="text-sm text-blue-600 font-medium" data-id="element-291">
                  +2.5% diese Woche
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-292">
              <h3 className="text-sm font-medium text-gray-500 mb-4" data-id="element-293">
                Export-Status
              </h3>
              <p className="text-2xl font-bold text-gray-900" data-id="element-294">OK</p>
              <div className="mt-2" data-id="element-295">
                <span className="text-sm text-gray-600" data-id="element-296">
                  Letzter Export: heute
                </span>
              </div>
            </div>
          </div>
          {/* Recent Activity */}
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-297">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-298">
              Letzte Aktivitäten
            </h2>
            <div className="space-y-4" data-id="element-299">
              {[{
              type: 'success',
              message: 'Neuer Beleg automatisch zugeordnet',
              detail: 'Amazon Rechnung - €49,99',
              time: 'Vor 5 Minuten'
            }, {
              type: 'warning',
              message: 'Beleg benötigt manuelle Prüfung',
              detail: 'Tankstelle - €65,30',
              time: 'Vor 2 Stunden'
            }, {
              type: 'info',
              message: 'Neue Banktransaktion importiert',
              detail: 'Eingang: €1.299,00',
              time: 'Vor 3 Stunden'
            }].map((activity, index) => <div key={index} className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg" data-id="element-300">
                  <div className={`w-2 h-2 rounded-full ${activity.type === 'success' ? 'bg-green-500' : activity.type === 'warning' ? 'bg-yellow-500' : 'bg-blue-500'}`} data-id="element-301" />
                  <div className="flex-1" data-id="element-302">
                    <p className="text-sm font-medium text-gray-900" data-id="element-303">
                      {activity.message}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-304">{activity.detail}</p>
                  </div>
                  <span className="text-sm text-gray-400" data-id="element-305">{activity.time}</span>
                </div>)}
            </div>
          </div>
        </main>
      </div>
    </div>;
};